import React from 'react';
import { Button, Alert, Modal } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import { hideMessage, showAuthLoader, userSignIn, signInWithToken, generateRecoveryKey } from 'actions/Auth';
import CircularProgress from 'components/CircularProgress';
import Moment from 'moment';
import swal from 'sweetalert';
import CardLayout from 'components/CardLayout/index';

class SignIn extends React.Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            recoveryInput: '',
            showRecoveryModal: false
        };
    }

    componentDidMount() {
        if (this.props.authUser && this.props.tokenExpireTime && Moment().diff(this.props.tokenExpireTime) < 0) {
            this.props.signInWithToken(this.props.authUser);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.authUser !== null && this.props.tokenExpireTime && Moment().diff(this.props.tokenExpireTime) < 0) {
            this.props.history.push('/');
        }

        if (prevProps.generateRecoveryKeyLoading && !this.props.generateRecoveryKeyLoading)
            this.setState({ showRecoveryModal: false, recoveryInput: '' }, () =>
                swal({
                    text: this.props.intl.formatMessage({
                        id: this.props.generateRecoveryKeyError ? 'loginPage.forgotPassword.error' : 'loginPage.forgotPassword.success'
                    }),
                    icon: this.props.generateRecoveryKeyError ? 'error' : 'success'
                })
            );
    }

    render() {
        const { email, password, recoveryInput, showRecoveryModal } = this.state;
        const { showMessage, loader, alertMessage, connectionError, generateRecoveryKeyLoading } = this.props;
        return (
            <div className="app-login-container d-flex flex-column justify-content-center align-items-center">
                <div className="app-login-main-content">
                    <div className="app-logo-content d-flex align-items-center justify-content-center bg-grey">
                        <Link className="logo-lg" to="/" title="Jambo">
                            <img src="assets/images/icon-meldooplus.svg" alt="Meldo-Icon" title="Meldoo" height={100} />
                        </Link>
                    </div>

                    <div className="app-login-content">
                        <div className="app-login-header mb-4">
                            <h1>
                                <IntlMessages id="loginPage.welcome" />
                            </h1>
                        </div>
                        {connectionError ? (
                            <div>
                                <Alert color="warning" className="d-flex">
                                    <div className="text-center pr-3">
                                        <i className="zmdi zmdi-settings" style={{ animation: 'zmdi-spin 3s infinite linear', fontSize: '4em' }} />
                                    </div>
                                    <div>
                                        <IntlMessages id="loginPage.maintainence" />
                                    </div>
                                </Alert>
                            </div>
                        ) : (
                            <div className="app-login-form">
                                <form
                                    onSubmit={event => {
                                        event.preventDefault();
                                        this.props.userSignIn(email, password);
                                    }}
                                >
                                    <div className="form-group mb-3">
                                        <input
                                            placeholder={this.props.intl.formatMessage({ id: 'common.userName' })}
                                            onChange={event =>
                                                this.setState({
                                                    email: event.target.value
                                                })
                                            }
                                            defaultValue={email}
                                            className="form-control form-control-lg"
                                            autoFocus
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <input
                                            type="password"
                                            placeholder={this.props.intl.formatMessage({ id: 'common.password' })}
                                            onChange={event =>
                                                this.setState({
                                                    password: event.target.value
                                                })
                                            }
                                            defaultValue={password}
                                            className="form-control form-control-lg"
                                        />
                                    </div>

                                    <div className="d-flex flex-column align-items-start justify-content-between">
                                        <Button type="submit" color="primary" className="text-uppercase">
                                            <IntlMessages id="loginPage.login" />
                                        </Button>
                                        <span className="pointer text-blue" onClick={() => this.setState({ showRecoveryModal: true })}>
                                            <IntlMessages id="loginPage.forgotPassword" />
                                        </span>
                                    </div>
                                </form>
                            </div>
                        )}
                    </div>
                </div>

                <div className="pt-3 pb-2">
                    <a href="https://www.meldooplus.de/v3/login">Zur Anmeldung für MeldooPLUS 3.0</a>
                </div>

                <Alert className="border mt-2 text-center" color="light">
                    <IntlMessages id="loginPage.browserInfo" />
                </Alert>

                {loader && (
                    <div className="loader-view">
                        <CircularProgress />
                    </div>
                )}
                {showMessage && NotificationManager.error(alertMessage)}
                <NotificationContainer />

                <div className="text-center">
                    <Modal
                        style={{
                            maxWidth: 'calc(100% - 1rem)',
                            width: 400,
                            height: 100
                        }}
                        isOpen={showRecoveryModal}
                    >
                        <CardLayout styleName="col-lg-12 m-0">
                            <div className="jr-card-header mb-3 d-flex align-items-center">
                                <span className="icon-btn size-30 jr-menu-icon mr-auto" onClick={() => this.setState({ showRecoveryModal: false })}>
                                    <i className="zmdi zmdi-close" />
                                </span>
                                <div className="mr-auto">
                                    <h3 className="card-heading mb-0">
                                        <IntlMessages id="loginPage.forgotPasswordTitle" />
                                    </h3>
                                </div>
                                <span className="icon-btn size-30 pointer" />
                            </div>
                            <p className="text-justify">
                                <IntlMessages id="loginPage.forgotPasswordInfo" />
                            </p>
                            <div className="form-group mb-3">
                                <input
                                    placeholder={this.props.intl.formatMessage({ id: 'common.userName' })}
                                    onChange={e =>
                                        this.setState({
                                            recoveryInput: e.target.value
                                        })
                                    }
                                    value={recoveryInput}
                                    className="form-control form-control-lg"
                                    autoFocus
                                />
                            </div>
                            <Button
                                color="primary"
                                className="jr-btn jr-btn-primary btn-block"
                                onClick={() => this.props.generateRecoveryKey(recoveryInput)}
                                disabled={generateRecoveryKeyLoading}
                                style={{ textTransform: 'none' }}
                            >
                                {generateRecoveryKeyLoading ? (
                                    <i className="zmdi zmdi-spinner zmdi-hc-spin" />
                                ) : (
                                    <IntlMessages id="loginPage.forgotPasswordAction" />
                                )}
                            </Button>
                        </CardLayout>
                    </Modal>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    const {
        loader,
        alertMessage,
        showMessage,
        authUser,
        tokenExpireTime,
        connectionError,
        generateRecoveryKeyLoading,
        generateRecoveryKeyError
    } = auth;
    return { loader, alertMessage, showMessage, authUser, tokenExpireTime, connectionError, generateRecoveryKeyLoading, generateRecoveryKeyError };
};

export default connect(
    mapStateToProps,
    {
        userSignIn,
        hideMessage,
        showAuthLoader,
        signInWithToken,
        generateRecoveryKey
    }
)(injectIntl(SignIn));



// WEBPACK FOOTER //
// ./containers/SignIn.js